<template>
  <v-app>
    <v-container v-if="!appMounted" fill-height grid-list-lg>
      <v-layout column align-center justify-center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          :indeterminate="!appMounted"
        ></v-progress-circular>
        <br />
        <div class="mt-2">Mohon Tunggu</div>
      </v-layout>
    </v-container>
    <v-app-bar
      v-if="appMounted && $route.name !== 'login'"
      dark
      class="primary"
      app
    >
      <v-toolbar-title class="headline text-uppercase hidden-sm-and-down">
        <span>SIMSP SETDA GARUT</span>
      </v-toolbar-title>
      <v-toolbar-title class="text-uppercase hidden-md-and-up">
        <span>SIMSP SETDA GARUT</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items class="hidden-sm-and-down">
        <template v-for="menu in menus">
          <v-btn
            :key="menu.id"
            class="btn-menu-custom"
            text
            @click="navigateTo(menu)"
            :disabled="menu.id === currentMenu"
            v-if="menu.to"
          >
            <v-icon left>{{ menu.icon }}</v-icon>
            {{ menu.text }}
          </v-btn>
        </template>
      </v-toolbar-items>
      <v-menu
        bottom
        right
        offset-y
        open-on-hover
        :max-width="350"
        v-if="hasPrivateAccess"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              :class="{ active: currentMenu === 'settings' }"
            >
              <v-icon left>mdi-settings</v-icon>
              Pengaturan
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar-items>
        </template>
        <v-list>
          <v-list-item
            v-if="hasPrivateAccess"
            @click="
              () => {
                $router.push('/kode-surat')
                this.currentMenu = 'settings'
              }
            "
          >
            <v-list-item-title>
              <v-icon left>mdi-counter</v-icon>
              Pengaturan Kode Surat
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="isSuperAdmin"></v-divider>
          <v-list-item
            v-if="isSuperAdmin"
            @click="
              () => {
                $router.push('/manajemen-pegawai')
                this.currentMenu = 'settings'
              }
            "
          >
            <v-list-item-title>
              <v-icon left>mdi-account-box-multiple</v-icon>
              Manajemen Pegawai
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="isSuperAdmin"
            @click="
              () => {
                $router.push('/manajemen-admin')
                this.currentMenu = 'settings'
              }
            "
          >
            <v-list-item-title>
              <v-icon left>mdi-account-box-outline</v-icon>
              Manajemen Admin
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu bottom right offset-y open-on-hover :max-width="350">
        <template v-slot:activator="{ on, attrs }">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              :class="{ active: currentMenu === 'account' }"
            >
              <v-icon left>mdi-account</v-icon>
              {{ isLoggedin ? $store.state.user.name : '' }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar-items>
        </template>
        <v-list>
          <v-list-item @click="alertLogout = true">
            <v-list-item-title>
              <v-icon left>mdi-logout</v-icon>
              Logout
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on" class="mr-1 d-md-none">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in menus"
            :key="index"
            @click="navigateTo(item)"
          >
            <v-list-item-title>
              <v-icon left>{{ item.icon }}</v-icon>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="alertLogout = true">
            <v-list-item-title>
              <v-icon left>mdi-logout</v-icon>
              Logout</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-row v-if="appMounted">
      <v-col cols="12" lg="10" md="10" sm="12" offset-lg="1" offset-md="1">
        <v-content>
          <v-snackbar
            v-model="snackbar"
            bottom
            :color="snackColor"
            :timeout="3000"
            dark
          >
            {{ snackText }}
            <v-btn text @click="snackbar = false">X</v-btn>
          </v-snackbar>
          <router-view @handle-snackbar="showSnackbar" />
        </v-content>
      </v-col>
    </v-row>
    <v-dialog v-model="alertLogout" persistent max-width="290">
      <v-card :loading="logingOut">
        <v-card-title>Yakin Logout?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="alertLogout = false">
            Tidak
          </v-btn>
          <v-btn color="red darken-1" text @click="logout">Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as auth from '@/services/auth'
import menus from '@/config/menus'
import { mapGetters } from 'vuex'
import { hasAccess } from '@/utils/roles'

export default {
  name: 'App',
  data: () => ({
    user: null,
    snackbar: false,
    snackText: '',
    snackColor: 'success',
    appMounted: false,
    currentMenu: '0',
    menus: [],
    alertLogout: false,
    logingOut: false
  }),
  created() {
    this.getUserInfo()
  },
  computed: {
    ...mapGetters(['isLoggedin', 'hasPrivateAccess', 'roles', 'isSuperAdmin'])
  },
  methods: {
    async getUserInfo() {
      this.user = null
      this.menu = []
      await auth
        .getUserInfo(this.$store)
        .then(response => {
          this.user = response.data
          this.menus = menus.filter(menu => {
            if (menu.roles.length === 0) {
              return true
            }
            return hasAccess(menu.roles, this.roles)
          })
          this.setActiveMenu()
          this.appMounted = true
        })
        .catch(() => {
          this.appMounted = true
        })
    },
    setActiveMenu() {
      for (let m of this.menus) {
        if (window.location.pathname == '/' + m.to) {
          this.currentMenu = m.id
          break
        }
      }
    },
    showSnackbar(text, color) {
      this.snackColor = color
      this.snackText = text
      this.snackbar = true
    },
    async logout() {
      this.logingOut = true
      await auth.removeAccessToken()
      window.location.reload()
      this.currentMenu = null
      this.logingOut = false
    },
    navigateTo(menu) {
      if (window.location.pathname != '/' + menu.to) {
        this.$router.push(menu.to)
      }
      this.currentMenu = menu.id
    }
  }
}
</script>

<style>
.v-data-table tbody td {
  font-size: 12px;
}

.v-data-table-header th {
  /* font-size: 12px !important; */
  color: #000 !important;
}

.oflow {
  line-height: 1.5;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 0px;
}

.active,
.btn-menu-custom.v-btn--disabled {
  border-bottom: 2px solid #fff;
}

.btn-menu-custom.v-btn--disabled span.v-btn__content {
  color: #fff;
}

.btn-menu-custom.v-btn--disabled i.v-icon::before {
  color: #fff;
}

.text-cari-waktu input {
  text-align: center;
}

.headline-container {
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
